(() => {
  const key = '__dsBrandButton';
  if (window[key]) { window[key](document); return; }
  const observed = new WeakSet();
  function init(scope) {
    const root = scope.matches?.('#ds-landing') ? scope : scope.querySelector('#ds-landing');
    if (!root || observed.has(root)) return;
    observed.add(root);
    const apply = () => {
      const button = root.querySelector('#_rsi-buy-now-button');
      if (!button) return;
      const values = { background: '#f47b20', color: '#42270f', 'border-color': '#dc690e' };
      for (const [name, value] of Object.entries(values)) {
        const probe = document.createElement('span');
        probe.style.setProperty(name, value, 'important');
        if (button.style.getPropertyValue(name) !== probe.style.getPropertyValue(name) || button.style.getPropertyPriority(name) !== 'important') button.style.setProperty(name, value, 'important');
      }
      const label = button.querySelector('span');
      if (label && root.dataset.ctaLabel && label.textContent !== root.dataset.ctaLabel) label.textContent = root.dataset.ctaLabel;
    };
    const observer = new MutationObserver(apply);
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'data-cta-label'] });
    apply();
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) observer.disconnect();
    });
  }
  window[key] = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
